{
  "overridesEnabledBadgeLabel": "上書きオン",
  "releaseBadgeAlpha": "アルファ版",
  "releaseBadgeBeta": "Beta",
  "releaseBadgeDev": "開発",
  "releaseBadgePoc": "POC"
}
